import { useLocation, useNavigate } from 'react-router-dom'
import { leaveCentralDePrivacidade } from 'common'
import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'
import { appContextReducerActions } from 'contexts/app-context/utils'
import { Routes } from 'common/constants'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'

import { setFallbackUnknownErrorPageContent, ERROR_ICON } from '../utils'
import { TUseUnknownErrorPageReturn } from '../types'

const useUnknownErrorPageContextAware = (): TUseUnknownErrorPageReturn => {
  const { isAppLoading, userLanguage, privacyCenterContent, dispatch, userSelectedEntity } =
    useAppContext()

  const navigate = useNavigate()

  const { state } = useLocation()

  const onClickHandler = () => {
    // set app error to false to allow navigation
    dispatch(appContextReducerActions.setError(false))

    if (state?.goTo && state.goTo !== Routes.LEAVE_TO_APP) navigate(state.goTo)

    if (!state?.goTo || state.goTo === Routes.LEAVE_TO_APP) leaveCentralDePrivacidade()
  }

  const content =
    !isEmpty(privacyCenterContent?.components?.unknownErrorPage?.content) &&
    !!privacyCenterContent?.components?.unknownErrorPage?.isActive
      ? privacyCenterContent?.components?.unknownErrorPage?.content
      : setFallbackUnknownErrorPageContent(userLanguage)

  useScreenFinishLoadTac({
    name: 'UnknownErrorPageContextAware',
    entity: userSelectedEntity,
    action: 'UnknownErrorPageContextAware',
    screen: Routes.ERROR,
    shouldSend: true,
    logLabel: 'send unknown error context aware tac',
  })

  return {
    isLoading: isAppLoading,
    button: {
      onClick: onClickHandler,
      text: content.confirmButton,
    },
    content: {
      ...content,
      icon: content.icon ?? ERROR_ICON,
    },
  }
}

export { useUnknownErrorPageContextAware }
